/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_New_PostInputs */

const cs_blog_new_post = /** @type {(inputs: Blog_New_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový článek`)
};

const en_blog_new_post = /** @type {(inputs: Blog_New_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New article`)
};

/**
* | output |
* | --- |
* | "New article" |
*
* @param {Blog_New_PostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_new_post = /** @type {((inputs?: Blog_New_PostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_New_PostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_new_post(inputs)
	return cs_blog_new_post(inputs)
});